import React from 'react';
import { Link } from 'gatsby';
import { Container, Row, Col } from 'react-bootstrap';

import './byType.scss';
import classNames from 'classnames';



export default ({ location }) => {
  return (
    <Container className={'article-types-filter'}>
      <Row className="justify-content-center">
        <Col>
          <Link
            to="/articles"
            className={classNames('btn btn-secondary', {
              active:
                location.pathname === '/articles/' ||
                location.pathname === '/articles',
            })}
          >
            All
          </Link>
          <Link
            to="/articles/blog"
            className={classNames('btn btn-secondary', {
              active:
                location.pathname === '/articles/blog/' ||
                location.pathname === '/articles/blog',
            })}
          >
            Blog
          </Link>
          <Link
            to="/articles/news"
            className={classNames('btn btn-secondary', {
              active:
                location.pathname === '/articles/news/' ||
                location.pathname === '/articles/news',
            })}
          >
            News
          </Link>
          <Link
            to="/articles/press-releases"
            className={classNames('btn btn-secondary', {
              active:
                location.pathname === '/articles/press-releases/' ||
                location.pathname === '/articles/press-releases',
            })}
          >
            Press Releases
          </Link>
        </Col>
      </Row>
    </Container>
  );
};
